var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-picture"},[_c('div',{staticClass:"picture",style:({ backgroundImage: ("url('/static/img/live" + _vm.pictureId + ".jpg')") })})])}
var staticRenderFns = []

export { render, staticRenderFns }